<template>
  <nx-bform ref="form" @submit="onSubmit">
    <h5>
      {{ $t("title") }}
    </h5>
    <!-- <p class="text-muted">
      {{ $t("titleDesc") }}
    </p> -->

    <nx-bform-server-errors />

    <RegistrationContactAddressFormGroup
      label-cols="2"
      label-align="right"
      v-model="form.address"
      required
    />

    <b-form-group label-cols="2">
      <b-button type="submit" variant="primary" v-t="'send'" />
      <b-button class="ml-2" @click="resetForm" v-t="'cancel'" />
    </b-form-group>
  </nx-bform>
</template>

<script>
import { RequestRegistrationApi } from "@/api";
import RegistrationContactAddressFormGroup from "@/forms/registration/RegistrationContactAddressFormGroup";

export default {
  components: {
    RegistrationContactAddressFormGroup
  },
  props: {
    invitationKey: {
      type: String
    }
  },
  data() {
    return {
      form: this.getForm()
    };
  },
  methods: {
    getForm() {
      return {
        address: ""
      };
    },
    async onSubmit() {
      const { form, invitationKey } = this;

      await RequestRegistrationApi.requestAccountExist({
        contactAddress: form.address,
        guid: invitationKey
      });

      await this.$store.dispatch("userStore/refresh");

      this.$router.push({ name: "Home" });
    },
    resetForm() {
      this.form = this.getForm();
      this.$refs.form.reset();
    }
  }
};
</script>

<style lang="scss" scoped></style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n>
{
  "en": {
    "title": "Application for registration as an owner of Electronic Submission Hub",
    "titleDesc": "To become a registered user, please complete the following application form. All fields with (*) are mandatory."
  },
  "zh_hk": {
    "title": "申請註冊為電子資料呈交及處理系統的業主/擁有人",
    "titleDesc": "要成為註冊用戶，請填寫以下申請表格。帶（*）的所有字段均為必填項。"
  },
  "zh_cn": {
    "title": "申请注册为电子资料呈交及处理系统的业主/拥有人",
    "titleDesc": "要成为注册用户，请填写以下申请表格。带（*）的所有字段均为必填项。"
  }
}
</i18n>
